export enum APP_ACTIONS {
	SET_LOADING = '[App] Set loading',
	ADD_LOADING_URL = '[App] Add loading URL',
	REMOVE_LOADING_URL = '[App] Remove loading URL',
	SET_ERROR = '[App] Set Error',
	CLEAR_ERROR = '[App] Clear Error',
	ALLOW_SESSION_CREATION = '[App] Allow Session Creation',
	DISALLOW_SESSION_CREATION = '[App] Disallow Session Creation',
}

export namespace AppActions {
	export class SetLoading {
		static readonly type = APP_ACTIONS.SET_LOADING
		constructor(public payload: boolean) {}
	}

	export class AddLoadingUrl {
		static readonly type = APP_ACTIONS.ADD_LOADING_URL
		constructor(public payload: string) {}
	}

	export class RemoveLoadingUrl {
		static readonly type = APP_ACTIONS.REMOVE_LOADING_URL
		constructor(public payload: string) {}
	}

	export class SetError {
		static readonly type = APP_ACTIONS.SET_ERROR
		/**
		 * @param payload The message that will be displayed to the user
		 */
		constructor(public payload: string) {}
	}

	export class ClearError {
		static readonly type = APP_ACTIONS.CLEAR_ERROR
	}

	export class AllowSessionCreation {
		static readonly type = APP_ACTIONS.ALLOW_SESSION_CREATION
	}

	export class DisallowSessionCreation {
		static readonly type = APP_ACTIONS.DISALLOW_SESSION_CREATION
	}
}
